import { apiRequest } from "./apiRequest";

export const CHANGE_LOG_PAGE_SIZE = 10;
export const CHANGE_LOG_ENTRY_PAGE_SIZE = 25;

export function changeLogUrl(companyId, page = 1, pageSize = CHANGE_LOG_PAGE_SIZE, options = {}) {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (options.projectName) {
    params.set("project_name", options.projectName);
  }
  return `${process.env.REACT_APP_API_BASE_URL}/companies/${companyId}/change-log/?${params}`;
}

export function changeLogEntriesUrl(
  companyId,
  changeLogId,
  page = 1,
  pageSize = CHANGE_LOG_ENTRY_PAGE_SIZE,
  options = {}
) {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (options.projectName) {
    params.set("project_name", options.projectName);
  }
  return `${process.env.REACT_APP_API_BASE_URL}/companies/${companyId}/change-log/${changeLogId}/entries/?${params}`;
}

export async function fetchChangeLogPage(companyId, page, options = {}) {
  const pageSize = options.pageSize ?? CHANGE_LOG_PAGE_SIZE;
  return apiRequest(changeLogUrl(companyId, page, pageSize, options), {
    method: "GET",
    suppressErrorToast: options.suppressErrorToast ?? true,
    forceRefresh: options.forceRefresh ?? false,
  });
}

export async function fetchChangeLogEntriesPage(companyId, changeLogId, page, options = {}) {
  const pageSize = options.pageSize ?? CHANGE_LOG_ENTRY_PAGE_SIZE;
  return apiRequest(changeLogEntriesUrl(companyId, changeLogId, page, pageSize, options), {
    method: "GET",
    suppressErrorToast: options.suppressErrorToast ?? true,
    forceRefresh: options.forceRefresh ?? false,
  });
}
